import React, {Component} from 'react'
import { Link } from 'react-router-dom'
import bgbox from '../img/nosotros/bgbox1.jpg'
import Logo from '../componentes/Logo'
import Social from '../componentes/Social'

class Footer extends Component {
	constructor(props) {
		super(props)
        this.state = {
            img1 : bgbox
        }
    }
    render(){
        return (
            <footer id="footer" className="footer">
                <div className="wrap">
                    <div className="r">
                        <Logo />
                        <img src={this.state.img1} alt="Spring's Hotel"/>
                    </div>
                    <div className="l">
                        <ul className="pages">
                            <li><Link to={"/nosotros"}>Nosotros</Link></li>
                            <li><Link to={"/dormitorios"}>Dormitorios</Link></li>
                            <li><Link to={"#"}>Blog</Link></li>
                            <li><Link to={"/contacto"}>Contacto</Link></li>
                            <li><Link to={"#"}>Términos y condiciones</Link></li>
                        </ul>
                        <p>
                            Comunícate con nosotros al <a href="tel:+51972603177"> +51 972 603 177</a>.
                            Nos ubicamos en Calle Los Jeranios #A16, Pichanaki 12867, Perú.
                        </p>
                        <Social />
                    </div>
                </div>
                <span class="develop">© 2019 Spring's Hotel - Todos los derechos reservados.</span>
            </footer>
        )
    }
}

export default Footer